module.exports = __webpack_public_path__ + "static/img/bg.c5e16b18.jpg";